import styled from 'styled-components';

import {SimpleTable, TypographyCard} from '@dms/teas';

export const SearchContainer = styled.div`
  padding: ${({theme}) => theme.getSize(3)};
  max-width: 175px;
`;

export const StyledCard = styled(TypographyCard)`
  width: 100%;
`;

export const StyledTable = styled(SimpleTable)`
  .action-column {
    width: 32px;
  }

  .simple-table-th {
    font-size: ${({theme}) => theme.fontSizes.text.small};
    font-weight: ${({theme}) => theme.fontWeights.medium};
    color: ${({theme}) => theme.colors.text.secondary};
  }

  .row-disabled td:not(:last-child) {
    opacity: 0.5;
  }
`;
